<template>
    <div>
        <el-form ref="queryParams" inline label-position="right" label-width="10px" v-model="queryParams">
            <el-form-item>
                <el-date-picker type="month" placeholder="选择月份" @change="cbtime" v-model="others.btime" style="width: 160px" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <Table style="min-height:500px" :loading="loading" :columns="columns" :data="merchants" border>
        </Table>
    </div>
</template>
<script>
export default {
    name: 'Payment',
    data() {
        return {
            loading: false,
            merchants: [],
            warehouses: [],
            queryParams: {

                year: 0
            },
            others: {
                btime: ""
            },

            rules: {},
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',

                    align: 'center'
                }, {
                    title: '姓名',
                    key: 'name',
                    width: 360,
                    align: 'center'
                }, {
                    title: '订单出库',
                    key: 'todayOutgoing',
                    width: 360,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todayOutgoing)
                        ]);
                    }
                }, {
                    title: '包裹签收',
                    key: 'todaySign',
                    width: 360,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [


                            h("div", { style: {}, class: { tips: true } }, params.row.todaySign)
                        ]);
                    }
                }

            ]
        };
    },
    mounted: function() {
        this.others.btime = this.long2date(new Date().getTime() / 1000);
        this.queryParams.btime = this.others.btime;
        this.getList();
    },
    methods: {
        cbtime: function(value) {
            this.queryParams.btime = value;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;

            me.loading = true;
            me.$http.post("/ware/stastis/usermonthreport.action", params).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.merchants = body.obj;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        }
    }
}
</script>
<style scoped>
.tips {
    color: #ff9900;
    font-size: 16px;
    margin-left: 10px;
}

.tips.success {
    color: #19be6b
}

.tips.error {
    color: #ed4014
}

.tips.info {
    color: #2db7f5
}
</style>